import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
export function blobReader(_x, _x2) {
  return _blobReader.apply(this, arguments);
}
function _blobReader() {
  _blobReader = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(blob, onChunk) {
    var chunkSize,
      size,
      totalBytesRead,
      slice,
      _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            chunkSize = _args.length > 2 && _args[2] !== undefined ? _args[2] : 1024 * 1024;
            size = blob.size;
            totalBytesRead = 0;
          case 3:
            if (!(totalBytesRead < size)) {
              _context.next = 15;
              break;
            }
            slice = blob.slice(totalBytesRead, Math.min(size, totalBytesRead + chunkSize));
            _context.t0 = onChunk;
            _context.t1 = Uint8Array;
            _context.next = 9;
            return slice.arrayBuffer();
          case 9:
            _context.t2 = _context.sent;
            _context.t3 = new _context.t1(_context.t2);
            (0, _context.t0)(_context.t3);
            totalBytesRead += slice.size;
            _context.next = 3;
            break;
          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _blobReader.apply(this, arguments);
}